import { BasicAccountModel } from './accounts';
import { ConversationModel } from './conversations';
import { GoalModel } from './goals';
import { GoalProgressModel } from './progress';
import { GoalSubscriptionPriority, GoalSubscriptionStatus } from './shared';
import { UserModel } from './users';

interface GetGoalSubscriptionsParamsModel {
  query?: string;
  statuses?: GoalSubscriptionStatus[];
  goalEntityIds?: string[];
  excludeChildGoals?: boolean;
}
interface GoalSubscriptionProgressElementModel {
  id: number;
  status: string;
}

interface GoalSubscriptionModel {
  id: number;
  priority: GoalSubscriptionPriority;
  deadline: string;
  completedAt: string;
  status: GoalSubscriptionStatus;
  strategyEndReached: boolean;
  conversationId: number;
  progressTaskAssignments: GoalSubscriptionProgressElementModel[];
  progressTaskAssignmentsEstimatedCount: number;
  createdAt: string;
  estimatedCompletedAt: string | null;
  verificationId: string;
  user: UserModel;
  goal: GoalModel;
  conversation: ConversationModel;
  progress?: GoalProgressModel;
  frozenAt: string | null;
  hasNewContent: boolean;
}

interface GoalSubscriptionCheckoutSessionModel {
  checkoutUrl: string;
  publishableKey: string;
}

interface CreateGoalSubscriptionModel {
  goalEntityId: string;
  priority?: GoalSubscriptionPriority;
  deadline?: string;
}

interface CreatedGoalSubscriptionModel {
  success: boolean;
  id?: number;
  priority?: GoalSubscriptionPriority;
  status?: GoalSubscriptionStatus;
  checkoutSession?: GoalSubscriptionCheckoutSessionModel;
}

interface GoalSubscriptionGetFiltersModel {
  goalEntityId?: string;
  status?: GoalSubscriptionStatus;
}

interface GoalSubscriptionStatusCount {
  status: GoalSubscriptionStatus;
  count: number;
}

interface GoalSubscriptionsSummaryModel {
  userId: number;
  statusCounts: GoalSubscriptionStatusCount[];
  total: number;
}

enum GoalSubscriptionTab {
  CHAT = 'CHAT',
  PROGRESS = 'PROGRESS',
  INFO = 'INFO',
  SETTINGS = 'SETTINGS'
}

interface GoalSubscriptionVerificationModel {
  startedAt: string;
  completedAt: string | null;
  completionProgress: number;
  currentResult: number;
  status: GoalSubscriptionStatus;
  amountCompleted: number;
  amountTotal: number;
  goalEntityId: string;
  goal: GoalModel | null;
  improver: BasicAccountModel | null;
  mentor: BasicAccountModel | null;
  hasNewContent: boolean;
}

export { GoalSubscriptionPriority, GoalSubscriptionStatus, GoalSubscriptionTab };
export type {
  CreatedGoalSubscriptionModel,
  CreateGoalSubscriptionModel,
  GetGoalSubscriptionsParamsModel,
  GoalSubscriptionCheckoutSessionModel,
  GoalSubscriptionGetFiltersModel,
  GoalSubscriptionModel,
  GoalSubscriptionProgressElementModel,
  GoalSubscriptionsSummaryModel,
  GoalSubscriptionVerificationModel
};
